import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./i18n";
import { ThemeProvider } from "styled-components";
import { store } from "./store";
import { GlobalStyle } from "./common/GlobalStyle";
import { theme } from "./theme";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
);

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL || ""}/sw.js`).catch(() => {});
  });
}
